// LiBRARY
import React from 'react';
import { Drawer as AntDrawer, Tabs as AntTabs, Badge as AntBadge } from 'antd';

// CUSTOM MODULES
import PageTitle from 'shared_components/page_title';
import SearchPatientHeaderForm from './search_form/search_input';
import SearchPatientTable from './phlebo_result_table';
import PhleboPatientResult from './patient_phlebo_info';
import PhleboPager from './phlebo_pager';
import { moduleTitle, tablePageSize, drawerTitle, tabNames } from './settings';

//  CONSTANTS
const { TabPane } = AntTabs;

class Phlebo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			extractedPatients: [],
			forExtractionPatients: [],
			pageSize: tablePageSize,
			loading: false,
			showDrawer: false,
			patientInfo: null,
			currentPageForExtraction: 1,
			currentPageExtracted: 1,
		};

		this.searchForm = React.createRef();
	}

	handleChangeSize = pageSize => {
		this.setState({ pageSize });
	};

	clearPatients = () => {
		this.setState({
			extractedPatients: [],
			forExtractionPatients: [],
			currentPageForExtraction: 1,
			currentPageExtracted: 1,
		});
	};

	handlePageChangeForExtraction = page => {
		this.setState({ currentPageForExtraction: page });
	};

	handlePageChangeExtracted = page => {
		this.setState({ currentPageExtracted: page });
	};

	populateExtractedPatients = extractedPatients => {
		this.setState({ extractedPatients, currentPageExtracted: 1 });
	};

	populateForExtractionPatients = forExtractionPatients => {
		this.setState({ forExtractionPatients, currentPageForExtraction: 1 });
	};

	displayDrawer = patientRecord => {
		this.setState({
			showDrawer: true,
			patientInfo: patientRecord,
		});
	};

	onClosePhleboPatientResultDrawer = () => {
		this.setState(
			{
				showDrawer: false,
				loading: true,
			},
			async () => {
				// @ts-ignore
				await this.searchForm.refreshSearch();

				this.setState({ loading: false });
			},
		);
	};

	render() {
		const {
			extractedPatients,
			forExtractionPatients,
			pageSize,
			loading,
			showDrawer,
			patientInfo,
			currentPageForExtraction,
			currentPageExtracted,
		} = this.state;
		const forExtrationPatientLength =
			forExtractionPatients === undefined || forExtractionPatients.length === 0
				? 0
				: forExtractionPatients.length;
		const extractedPatientLength =
			extractedPatients === undefined || extractedPatients.length === 0
				? 0
				: extractedPatients.length;

		return (
			<div>
				<div>
					<PageTitle pageTitle={moduleTitle} />
					<div className="space-y-md"></div>
					<SearchPatientHeaderForm
						// @ts-ignore
						ref={instance => (this.searchForm = instance)}
						clearPatients={this.clearPatients}
						populateExtractedPatients={this.populateExtractedPatients}
						populateForExtractionPatients={this.populateForExtractionPatients}
					/>
					<div className="space-y-md"></div>
					<AntTabs defaultActiveKey="1">
						<TabPane
							tab={
								<span>
									{tabNames.forExtraction}
									<AntBadge count={forExtrationPatientLength} />
								</span>
							}
							key="1"
						>
							<PhleboPager
								pageSize={pageSize}
								pageTotal={forExtrationPatientLength}
								currentPage={currentPageForExtraction}
								handleChangeSize={this.handleChangeSize}
							/>
							<div className="space-y-sm"></div>
							<SearchPatientTable
								data={forExtractionPatients}
								pageSize={pageSize}
								loading={loading}
								redirectUrl=""
								drawer={this.displayDrawer}
								onPageChange={this.handlePageChangeForExtraction}
								currentPage={currentPageForExtraction}
							/>
						</TabPane>
						<TabPane
							tab={
								<span>
									{tabNames.extracted}
									<AntBadge count={extractedPatientLength} />
								</span>
							}
							key="2"
						>
							<PhleboPager
								pageSize={pageSize}
								pageTotal={extractedPatientLength}
								currentPage={currentPageExtracted}
								handleChangeSize={this.handleChangeSize}
							/>
							<div className="space-y-sm"></div>
							<SearchPatientTable
								data={extractedPatients}
								pageSize={pageSize}
								loading={loading}
								redirectUrl=""
								drawer={this.displayDrawer}
								onPageChange={this.handlePageChangeExtracted}
								currentPage={currentPageExtracted}
							/>
						</TabPane>
					</AntTabs>
					{showDrawer && (
						<AntDrawer
							title={drawerTitle}
							onClose={this.onClosePhleboPatientResultDrawer}
							width="95%"
							visible
						>
							<PhleboPatientResult patientInfo={patientInfo} />
						</AntDrawer>
					)}
				</div>
			</div>
		);
	}
}

export default Phlebo;
